var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.driverPage.records},scopedSlots:_vm._u([{key:"operation",fn:function(){return [_c('a-space',[_c('a-button',{attrs:{"type":"link"}},[_vm._v("编辑")])],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }